<template>
    <section>
        <h2 class="h2Title">SMS 발송 관리</h2>
        <div class="tabs">
            <ul class="tabMenu">
                <li class="tabList" v-for="(tab, idx) in tabs" v-bind:class="{active: currentTab === idx}" :key="idx">
                    <button type="button" class="tabsTit" v-on:click="currentTab = idx">{{tab}}</button>
                </li>
            </ul>
        </div>
        <div class="tabContentBx">
            <div v-show="currentTab === 0" class="tabContent">
                <SmsSend/>
            </div>
            <div v-show="currentTab === 1" class="tabContent">
                <SmsSetting />
            </div>
            <div v-show="currentTab === 2" class="tabContent">
                <SmsHistory />
            </div>
        </div>
    </section>
</template>

<script>
    import SmsSend from "./SmsSend";
    import SmsSetting from "./SmsSetting";
    import SmsHistory from "./SmsHistory";

    export default {
        name: "Sms",
        components: {SmsHistory, SmsSetting, SmsSend},        
        data: () => ({
            currentTab: 0,
            tabs: ['SMS 발송', '시스템 발송 SMS 템플릿', 'SMS 발송 이력']
        }),
      created() {
      }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/style/layout/variables';

    .h2Title {
        @include h2-title;
    }
    .tabMenu {
        display: flex;
        border-bottom: 1px solid $point-color;
        margin-bottom: 20px;

        .tabList {
            display: flex;
            align-items: center;
            position: relative;
            height: 47px;
            border-top: 1px solid $gary-color;
            border-right: 1px solid $gary-color;

            &:first-child {
                border-left: 1px solid $gary-color;
            }

            &.active {
                border-top: 1px solid $point-color;
                border-left: 1px solid $point-color;
                border-right: 1px solid $point-color;
                border-bottom: 1px solid $white-color;

                &::before, &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    width: 100%;
                }

                &::before {
                    top: 0;
                    border-top: 3px solid $point-color;
                }

                &::after {
                    bottom: -2px;
                    border-top: 1px solid $white-color;
                }
            }

            .tabsTit {
                position: relative;
                top: 3px;
                height: 100%;
                padding: 0 40px;
            }
        }
    }
</style>